var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.9917C0.5 4.57342 4.08172 0.991699 8.5 0.991699C12.9183 0.991699 16.5 4.57342 16.5 8.9917C16.5 13.41 12.9183 16.9917 8.5 16.9917C4.08172 16.9917 0.5 13.41 0.5 8.9917Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.9917C0.5 4.57342 4.08172 0.991699 8.5 0.991699C12.9183 0.991699 16.5 4.57342 16.5 8.9917C16.5 13.41 12.9183 16.9917 8.5 16.9917C4.08172 16.9917 0.5 13.41 0.5 8.9917Z",
    stroke: "#525252",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.9917C4 6.50642 6.01472 4.4917 8.5 4.4917C10.9853 4.4917 13 6.50642 13 8.9917C13 11.477 10.9853 13.4917 8.5 13.4917C6.01472 13.4917 4 11.477 4 8.9917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBox);
export default __webpack_public_path__ + "static/media/checkedBox.2d04445973ac7801fed6669d2828ce4c.svg";
export { ForwardRef as ReactComponent };